import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
        Copyrigth &#169; 2024 Martin Dotto. All right received.
    </footer>
  )
}

export default Footer
